"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = require("react-redux");

var _payments = require("redux/modules/payments");

var _customer = require("redux/modules/customer");

var _address = require("redux/modules/address");

var _components = require("components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentSettingsPopup = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(PaymentSettingsPopup, _React$Component);

  function PaymentSettingsPopup(props) {
    (0, _classCallCheck3.default)(this, PaymentSettingsPopup);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PaymentSettingsPopup.__proto__ || (0, _getPrototypeOf2.default)(PaymentSettingsPopup)).call(this, props));

    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.handleCreditCardPrepare = _this.handleCreditCardPrepare.bind(_this);
    _this.handlePayPalPrepare = _this.handlePayPalPrepare.bind(_this);
    _this.setPayPalState = _this.setPayPalState.bind(_this);
    _this.setCreditCardState = _this.setCreditCardState.bind(_this);
    _this.handleCaptchaChange = _this.handleCaptchaChange.bind(_this);

    _this.state = {
      message: null,
      paymentType: "",
      paypalPrepared: false,
      _error: null
    };
    return _this;
  }

  (0, _createClass3.default)(PaymentSettingsPopup, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.getCustomer();
      this.props.getNextBillingPrice();
      this.props.cleanError();
      this.props.resetPostalCode();

      var _props$customer$custo = this.props.customer.customer,
          countryCode = _props$customer$custo.countryCode,
          postalCode = _props$customer$custo.postalCode;

      if (countryCode === "US" || countryCode === "CA") {
        this.props.validatePostalCode({ countryCode: countryCode, postalCode: postalCode });
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.state.paymentType !== nextState.paymentType) {
        this.setState({
          paypalPrepared: false
        });
        return true;
      }
      if (this.state.message !== nextState.message) {
        return true;
      }
      if (this.state._error !== nextState._error) {
        return true;
      }
      if (this.props.customer.updatingPaymentMethod !== nextProps.customer.updatingPaymentMethod) {
        return true;
      }
      if (this.props.nonce !== nextProps.nonce) {
        return true;
      }
      if (this.props.paypalEmail !== nextProps.paypalEmail) {
        return true;
      }
      if (this.props.clientToken !== nextProps.clientToken) {
        return true;
      }
      if (this.props.nextBillingPrice.loading !== nextProps.nextBillingPrice.loading) {
        return true;
      }

      return false;
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(values) {
      var _this2 = this;

      this.setState({
        message: null
      });

      var _props$address = this.props.address,
          stateList = _props$address.stateList,
          addressError = _props$address.error;
      var customer = this.props.customer.customer;
      var countryCode = customer.countryCode,
          customerState = customer.state,
          customerCity = customer.city;


      var state = stateList && stateList.find(function (x) {
        return x !== "undefined";
      });
      var city = state && state.cities && state.cities.find(function (city) {
        if (customerCity) {
          return city.toLowerCase() === customerCity.toLowerCase();
        }
        return false;
      });

      if ((countryCode === "US" || countryCode === "CA") && addressError) {
        this.setState({
          _error: "Please specify your postal code by going to Change Billing Address."
        });
        return;
      }

      if ((countryCode === "US" || countryCode === "CA") && (!customerState || (state && state.name) !== customerState)) {
        this.setState({
          _error: "Please specify your state by going to Change Billing Address."
        });
        return;
      }

      if (countryCode === "IN" && !customerState) {
        this.setState({
          _error: "Please specify your state by going to Change Billing Address."
        });
        return;
      }

      if ((countryCode === "US" || countryCode === "CA") && !city) {
        this.setState({
          _error: "Please specify your city by going to Change Billing Address."
        });
        return;
      }

      setTimeout(function () {
        return _this2.props.updatePaymentMethod({
          values: (0, _extends3.default)({}, values, !values.mainDivision && state && { mainDivision: state && state.code })
        }).then(function (res) {
          _this2.setState({
            message: res.type ? "Successfully updated payment settings" : res.isError ? res.msg : "Successfully updated payment settings"
          });
        }).catch(function (res) {
          _this2.setState({
            _error: res.message
          });
        });
      }, 2000);
    }
  }, {
    key: "handlePayPalPrepare",
    value: function handlePayPalPrepare() {
      var singleUse = false;
      var amount = 0;
      var currency = "USD";
      this.props.paypalNonce({
        container: "paypal-container",
        singleUse: singleUse,
        amount: amount,
        currency: currency
      });
    }
  }, {
    key: "handleCaptchaChange",
    value: function handleCaptchaChange(value) {
      var paymentType = this.state.paymentType;


      if (value && paymentType === "pay-pal") {
        this.handlePayPalPrepare();
      } else if (value && paymentType === "cc") {
        //Plus check if  nonce is  present or not
        this.handleCreditCardPrepare();
      }
    }
  }, {
    key: "handleCreditCardPrepare",
    value: function handleCreditCardPrepare() {
      // Skip re-rendering of credit card fields, if captcha got expire.
      var elem = document.getElementById("braintree-hosted-field-number");
      if (!elem) {
        this.props.creditCardNonce(!elem);
      }
    }
  }, {
    key: "setCreditCardState",
    value: function setCreditCardState() {
      this.setState({
        paymentType: "cc"
      });
    }
  }, {
    key: "setPayPalState",
    value: function setPayPalState() {
      this.setState({
        paymentType: "pay-pal"
      });

      this.handlePayPalPrepare();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          _props$customer = _props.customer,
          customer = _props$customer.customer,
          updatingPaymentMethod = _props$customer.updatingPaymentMethod,
          error = _props$customer.error,
          nonce = _props.nonce,
          paypalEmail = _props.paypalEmail,
          onCancelSubscriptionClick = _props.onCancelSubscriptionClick,
          nextBillingPrice = _props.nextBillingPrice,
          user = _props.user;


      var paypal = customer.paymentMethod.paymentMethodInstrument === "paypal" && customer.paymentMethod.email ? customer.paymentMethod.email : null;
      var creditCard = customer.paymentMethod.last4;

      var existingMethod = paypal ? "Paypal (" + paypal + ")" : "Credit Card (**** **** **** " + creditCard + ")";

      var isUnrealUnlimited = user.subscription && user.subscription.planId === "unreal-unlimited";

      var nextCharge = null;
      var subscription = user.subscription;

      var _ref = subscription || {},
          expiresAt = _ref.expiresAt;

      if (expiresAt && (0, _moment2.default)(expiresAt).isAfter((0, _moment2.default)()) && nextBillingPrice && nextBillingPrice.price) {
        if (nextBillingPrice.vatAmount && nextBillingPrice.vatAmount > 0) {
          nextCharge = "You will be charged $" + nextBillingPrice.price + " ($" + nextBillingPrice.priceExcludingTax + " fee + $" + nextBillingPrice.vatAmount + " tax) on your next billing date, " + (0, _moment2.default)(expiresAt).format("MMMM DD, YYYY") + ".";
        } else {
          nextCharge = "You will be charged $" + nextBillingPrice.price + " on your next billing date, " + (0, _moment2.default)(expiresAt).format("MMMM DD, YYYY") + ".";
        }
      }

      return customer ? _react2.default.createElement(_components.PaymentSettingsForm, {
        nextCharge: nextCharge,
        initialValues: { paymentMethod: "cc" },
        paypalContainerId: "paypal-container",
        paypalEmail: paypalEmail,
        paypalConfirmationHelpText: "To save, press Save Changes below",
        updating: updatingPaymentMethod,
        _error: error || this.state._error,
        existingMethod: existingMethod,
        message: this.state.message,
        onPayPalPrepare: this.setPayPalState,
        paypalNonce: nonce,
        onSubmit: this.handleSubmit,
        paymentLogosSrc: "/icons/payment-icons.png",
        onCancelSubscriptionClick: !isUnrealUnlimited && onCancelSubscriptionClick,
        braintreeLink: "https://www.braintreegateway.com/merchants/2mgdr37qhn27xsmy/verified",
        renderCaptcha: function renderCaptcha(field) {
          return _react2.default.createElement(_components.Captcha, { field: field, onChange: _this3.handleCaptchaChange });
        },
        setCreditCardState: this.setCreditCardState,
        paypalPaymentBoxError: this.props.clientToken.error,
        creditCardPrepare: this.handleCreditCardPrepare
      }) : _react2.default.createElement(
        "div",
        null,
        "No saved payment details found!"
      );
    }
  }]);
  return PaymentSettingsPopup;
}(_react2.default.Component), _class.contextTypes = {
  dialogs: _react2.default.PropTypes.object
}, _temp);
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.user,
    customer: state.customer,
    userEmail: state.user.email,
    nonce: state.payments.currentPayment.nonce,
    paypalEmail: state.payments.currentPayment.paypalEmail,
    clientToken: state.payments.clientToken,
    nextBillingPrice: state.payments.nextBillingPrice,
    address: state.address
  };
}, {
  getCustomer: _customer.getCustomer,
  initPayment: _payments.initPayment,
  getNextBillingPrice: _payments.getNextBillingPrice,
  updatePaymentMethod: _payments.updatePaymentMethod,
  paypalNonce: _payments.paypalNonce,
  creditCardNonce: _payments.creditCardNonce,
  cleanError: _customer.cleanError,
  validatePostalCode: _address.validatePostalCode,
  resetPostalCode: _address.resetPostalCode
})(PaymentSettingsPopup);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PaymentSettingsPopup/PaymentSettingsPopup.jsx
// module id = 2813
// module chunks = 0